import 'assets/styles/App.css'
import 'primeicons/primeicons.css'
import 'primereact/resources/primereact.min.css'
import 'primereact/resources/themes/saga-blue/theme.css'

import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { Footer } from 'components/footer'
import { Navbar } from 'components/navbar/navbar'
import SessionExpirationNotification from 'components/notification/SessionExpirationNotification'
import { AuthContextProvider } from 'context/AuthContext'
import { SelectedEventForScanProvider } from 'context/SelectedEventForScan'
import { GlobalStyles } from 'GlobalStyles'
import { PrimeReactProvider } from 'primereact/api'
import { useEffect } from 'react'
import { Toaster } from 'react-hot-toast'
import { useLocation } from 'react-router-dom'
import styled from 'styled-components'

import { AppRoutes } from './AppRoutes'

const AppBody = styled.div`
    display: flex;
    flex-direction: column;
    min-height: 100vh;

    @media (max-width: 768px) {
        min-height: unset;
    }

    @media (max-width: 768px) {
        min-height: unset;
    }
`

const ContentWrapper = styled.div`
    flex-grow: 1;
    margin-bottom: 2rem;
    padding-top: 90px;

    @media (max-width: 768px) {
        margin-bottom: unset;
    }

    @media (max-width: 768px) {
        margin-bottom: unset;
    }
`

export function App() {
    const queryClient = new QueryClient()
    const location = useLocation()

    const footerHiddenPaths = ['/admin/jegyellenorzes', '/login']
    const hideFooter = footerHiddenPaths.some((path) => location.pathname.startsWith(path))

    useEffect(() => {
        if (location.pathname === '/kapcsolat') {
            const contactElement = document.getElementById('contact-section')
            if (contactElement) {
                contactElement.scrollIntoView({ behavior: 'smooth' })
            }
        }
    }, [location.pathname])

    return (
        <PrimeReactProvider>
            <QueryClientProvider client={queryClient}>
                <AuthContextProvider>
                    <SessionExpirationNotification>
                        <SelectedEventForScanProvider>
                            <GlobalStyles />
                            <Navbar />
                            <Toaster position="top-right" />
                            <AppBody id="app-body">
                                <ContentWrapper>
                                    <AppRoutes />
                                </ContentWrapper>
                                {!hideFooter && <Footer />}
                            </AppBody>
                        </SelectedEventForScanProvider>
                    </SessionExpirationNotification>
                </AuthContextProvider>
            </QueryClientProvider>
        </PrimeReactProvider>
    )
}
